module.exports = __webpack_public_path__ + "img/Final Model V3.c1bb8139.jpg";